var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notification-wrapper" },
    _vm._l(_vm.filteredNotifications, function (notification) {
      return _c(
        "div",
        {
          key: notification.id,
          class:
            "alert alert-dismissible fade in show alert-" +
            notification.context,
          attrs: { role: "alert" },
        },
        [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
              },
              on: {
                click: function ($event) {
                  return notification.close()
                },
              },
            },
            [
              _c("span", { attrs: { "aria-hidden": "true" } }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#f9f9f9",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.showErrorCode
            ? _c("strong", [_vm._v(_vm._s(notification.code))])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(notification.message) } }),
          _vm._v(" "),
          _vm._l(notification.stackTrace, function (trace, index) {
            return _c("p", { key: index, staticClass: "small" }, [
              _vm._v("\n      " + _vm._s(trace.message) + "\n    "),
            ])
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }